(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.cart-product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.cart-product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jv-main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function syncAlpine(root, id) {
      try {
        if (root._x_dataStack && root._x_dataStack[0]) {
          root._x_dataStack[0].activeMediaId = String(id || '');
        }
      } catch (e) {}
    }

    function pauseAllMedia(root) {
      root.querySelectorAll('[data-jv-slide] video').forEach(function (video) {
        try {
          video.pause();
        } catch (e) {}
      });
    }

    function playActiveMedia(slide) {
      if (!slide) return;
      var video = slide.querySelector('video');
      if (!video) return;
      video.muted = true;
      video.setAttribute('playsinline', '');
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    function activateMedia(root, mediaId, opts) {
      if (!mediaId) return;
      opts = opts || {};
      var shouldScroll = opts.scroll !== false;
      var slides = root.querySelectorAll('[data-jv-slide]');
      var thumbs = root.querySelectorAll('[data-jv-thumb]');
      var activeSlide = null;

      pauseAllMedia(root);

      slides.forEach(function (slide) {
        var isActive = String(slide.getAttribute('data-media-id')) === String(mediaId);
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        if (isActive) activeSlide = slide;
      });

      thumbs.forEach(function (thumb) {
        var isActive = String(thumb.getAttribute('data-media-id')) === String(mediaId);
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (isActive && shouldScroll) {
          try {
            thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
          } catch (e) {}
        }
      });

      syncAlpine(root, mediaId);
      playActiveMedia(activeSlide);
    }

    function initGallery(root) {
      if (!root || root.dataset.galleryBound === 'true') return;
      root.dataset.galleryBound = 'true';

      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-jv-thumb]'));
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-jv-slide]'));
      if (!slides.length) return;

      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          activateMedia(root, btn.getAttribute('data-media-id'));
        });
      });

      /* Pausar vídeos fora do slide ativo no load; tocar o ativo — sem scroll (evita piscar) */
      pauseAllMedia(root);
      var initial = root.querySelector('[data-jv-slide].is-active') || slides[0];
      if (initial) {
        activateMedia(root, initial.getAttribute('data-media-id'), { scroll: false });
      }

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          root.classList.add('is-gallery-ready');
        });
      });

      var main = root.querySelector('[data-jv-main-media]');
      if (!main || thumbs.length < 2) return;

      var startX = 0;
      var deltaX = 0;
      var tracking = false;

      main.addEventListener(
        'touchstart',
        function (e) {
          if (!e.touches || !e.touches[0]) return;
          tracking = true;
          startX = e.touches[0].clientX;
          deltaX = 0;
        },
        { passive: true }
      );

      main.addEventListener(
        'touchmove',
        function (e) {
          if (!tracking || !e.touches || !e.touches[0]) return;
          deltaX = e.touches[0].clientX - startX;
        },
        { passive: true }
      );

      main.addEventListener('touchend', function () {
        if (!tracking) return;
        tracking = false;
        if (Math.abs(deltaX) < 40) return;
        var current = root.querySelector('[data-jv-thumb].is-active');
        var index = thumbs.indexOf(current);
        if (index < 0) index = 0;
        var next = deltaX < 0 ? index + 1 : index - 1;
        if (next < 0 || next >= thumbs.length) return;
        activateMedia(root, thumbs[next].getAttribute('data-media-id'));
      });
    }

    function initCalc(root) {
      var calc = root.querySelector('[data-jv-calc]');
      if (!calc || calc.dataset.bound === 'true') return;
      calc.dataset.bound = 'true';
      function arr(s, def) {
        return s && s.trim()
          ? s.split(',').map(function (x) {
              return parseFloat(x);
            })
          : def;
      }
      var Rb = arr(calc.getAttribute('data-busto'), [86, 93, 100, 112]);
      var Rc = arr(calc.getAttribute('data-cintura'), [66, 73, 80, 88]);
      var Rq = arr(calc.getAttribute('data-quadril'), [92, 99, 106, 114]);
      var SZ =
        calc.getAttribute('data-sizes') && calc.getAttribute('data-sizes').trim()
          ? calc
              .getAttribute('data-sizes')
              .split(',')
              .map(function (x) {
                return x.trim();
              })
          : ['P', 'M', 'G', 'GG'];
      function idx(v, a) {
        for (var i = 0; i < a.length; i++) {
          if (v <= a[i]) return i;
        }
        return a.length - 1;
      }
      var go = calc.querySelector('[data-jv-calc-go]');
      if (!go) return;
      go.addEventListener('click', function () {
        var out = calc.querySelector('[data-jv-calc-out]');
        var a = parseFloat(calc.querySelector('.jv-ma').value);
        var b = parseFloat(calc.querySelector('.jv-mb').value);
        var c = parseFloat(calc.querySelector('.jv-mc').value);
        var q = parseFloat(calc.querySelector('.jv-mq').value);
        if (!b || !c || !q) {
          out.textContent = 'Preencha busto, cintura e quadril.';
          return;
        }
        var i = Math.max(idx(b, Rb), idx(c, Rc), idx(q, Rq));
        var size = SZ[i] || SZ[SZ.length - 1];
        var extra = a && a >= 175 ? ' · dica: para mais comprimento, considere o próximo tamanho' : '';
        out.innerHTML = 'Tamanho recomendado: <b>' + size + '</b>' + extra;
        root.querySelectorAll('.jv-pdp__size').forEach(function (btn) {
          if (btn.textContent.trim() === size) btn.click();
        });
      });
    }

    function boot() {
      document.querySelectorAll('.jv-pdp').forEach(function (root) {
        initGallery(root);
        initCalc(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('.jv-pdp').forEach(function (root) {
        root.dataset.galleryBound = '';
        var calc = root.querySelector('[data-jv-calc]');
        if (calc) calc.dataset.bound = '';
      });
      boot();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-bottom-nav"] && !Shopify.designMode) return;
  try {
    
    class MobileBottomNav extends HTMLElement {
      connectedCallback() {
        this.lastScrollY = window.scrollY;
        this.scrollThreshold = Number(this.dataset.scrollThreshold) || 12;
        this.hideOnScroll = this.dataset.hideOnScroll === 'true';
        this.hideWhenStickyVisible = this.dataset.hideWhenStickyVisible === 'true';
        this.stickySelector = (this.dataset.stickyOverlaySelector || '.jv-pdp__sticky').trim();
        this.ticking = false;
        this.enablePageTransition = this.dataset.enablePageTransition === 'true';
        this.stickyObserver = null;
        this.stickyMutationObserver = null;

        this.handleScroll = this.handleScroll.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleClick = this.handleClick.bind(this);

        if (!this.isAppAllowed()) {
          this.classList.add('is-app-blocked');
          this.setAttribute('hidden', '');
          this.setAttribute('aria-hidden', 'true');
          return;
        }

        // Só aplica classes no html quando app_only (CSS imediato cobre o caso default).
        if (this.dataset.appOnly === 'true') {
          this.applyHeaderIconVisibility(true);
        }

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleResize, { passive: true });
        this.addEventListener('click', this.handleClick);

        // Transitions só depois do 1.º paint (evita animar estado ativo do Liquid).
        window.requestAnimationFrame(() => {
          this.classList.add('is-ready');
        });

        if (this.enablePageTransition) {
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              this.classList.add('is-entered');
            });
          });
        }

        this.bindStickyObservers();
        this.updateState();
      }

      disconnectedCallback() {
        if (this.dataset.appOnly === 'true') {
          this.applyHeaderIconVisibility(false);
        }
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
        this.removeEventListener('click', this.handleClick);
        this.unbindStickyObservers();
      }

      isCapacitorApp() {
        return typeof window.Capacitor !== 'undefined';
      }

      isAppAllowed() {
        if (this.dataset.designMode === 'true') return true;
        if (this.dataset.appOnly !== 'true') return true;
        return this.isCapacitorApp();
      }

      applyHeaderIconVisibility(enable) {
        const root = document.documentElement;
        if (!enable) {
          root.classList.remove('mbn-hide-header-cart', 'mbn-hide-header-account');
          return;
        }
        if (this.dataset.hideHeaderCart === 'true') {
          root.classList.add('mbn-hide-header-cart');
        }
        if (this.dataset.hideHeaderAccount === 'true') {
          root.classList.add('mbn-hide-header-account');
        }
      }

      bindStickyObservers() {
        if (!this.hideWhenStickyVisible || !this.stickySelector) return;
        if (this.stickyObserver || this.stickyMutationObserver) return;

        const stickyEl = document.querySelector(this.stickySelector);
        if (!stickyEl) {
          this._stickyBindAttempts = (this._stickyBindAttempts || 0) + 1;
          if (this._stickyBindAttempts < 15) {
            window.setTimeout(() => this.bindStickyObservers(), 400);
          }
          return;
        }

        if (typeof IntersectionObserver === 'function') {
          this.stickyObserver = new IntersectionObserver(() => {
            this.updateState();
          }, { threshold: [0, 0.01, 1] });
          this.stickyObserver.observe(stickyEl);
        }

        if (typeof MutationObserver === 'function') {
          this.stickyMutationObserver = new MutationObserver(() => {
            this.updateState();
          });
          this.stickyMutationObserver.observe(stickyEl, {
            attributes: true,
            attributeFilter: ['style', 'class', 'hidden']
          });
        }
      }

      unbindStickyObservers() {
        if (this.stickyObserver) {
          this.stickyObserver.disconnect();
          this.stickyObserver = null;
        }
        if (this.stickyMutationObserver) {
          this.stickyMutationObserver.disconnect();
          this.stickyMutationObserver = null;
        }
      }

      handleClick(event) {
        const navLink = event.target.closest('.mobile-bottom-nav__link');
        if (navLink && this.contains(navLink) && this.dataset.enableIconAnimation === 'true') {
          const item = navLink.closest('.mobile-bottom-nav__item');
          if (item) {
            item.classList.remove('is-bounce');
            void item.offsetWidth;
            item.classList.add('is-bounce');
            const clearBounce = () => item.classList.remove('is-bounce');
            item.addEventListener('animationend', clearBounce, { once: true });
          }
        }

        const actionLink = event.target.closest('[data-mobile-nav-action]');
        if (!actionLink || !this.contains(actionLink)) return;

        const action = actionLink.getAttribute('data-mobile-nav-action');

        if (action === 'open-cart') {
          const cartType = this.dataset.cartType || 'drawer';
          if (cartType === 'drawer' || cartType === 'side') {
            event.preventDefault();
            this.openCartDrawer();
          }
          // cart_type == page → segue o href /cart normalmente
          return;
        }

        if (action === 'open-account') {
          // Mesmo fluxo do header Pozze: navega para conta/login.
          return;
        }

        if (action === 'open-feed') {
          event.preventDefault();
          const feed = window.videoFeed || document.querySelector('video-feed');
          if (feed && typeof feed.open === 'function') {
            feed.open();
          }
          return;
        }

        if (action === 'go-back') {
          event.preventDefault();
          this.goBack(actionLink.getAttribute('href') || this.dataset.homeUrl || '/');
          return;
        }
      }

      goBack(homeUrl) {
        const fallback = homeUrl || this.dataset.homeUrl || '/';
        let canUseHistory = false;

        try {
          if (document.referrer) {
            const ref = new URL(document.referrer);
            if (ref.origin === window.location.origin) {
              canUseHistory = window.history.length > 1;
            }
          }
        } catch (e) {
          canUseHistory = false;
        }

        if (canUseHistory) {
          window.history.back();
          return;
        }

        window.location.href = fallback;
      }

      openCartDrawer() {
        if (window.pzCart && typeof window.pzCart.open === 'function') {
          window.pzCart.open();
          if (typeof window.pzCart.refresh === 'function') window.pzCart.refresh();
          return;
        }

        document.dispatchEvent(
          new CustomEvent('show-cart', {
            detail: true,
            bubbles: true,
            composed: true,
            cancelable: true
          })
        );
      }
  
      handleScroll() {
        if (this.ticking) return;
  
        this.ticking = true;
        window.requestAnimationFrame(() => {
          this.updateState();
          this.ticking = false;
        });
      }
  
      handleResize() {
        this.updateState();
      }

      isStickyOverlayVisible() {
        if (!this.stickySelector) return false;
        const stickyEl = document.querySelector(this.stickySelector);
        if (!stickyEl) return false;

        if (stickyEl.hasAttribute('hidden')) return false;

        const styles = window.getComputedStyle(stickyEl);
        if (styles.display === 'none' || styles.visibility === 'hidden' || Number(styles.opacity) === 0) {
          return false;
        }

        const rect = stickyEl.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0) return false;

        // Visível na viewport (barra fixa no fundo).
        return rect.bottom > 0 && rect.top < window.innerHeight;
      }

      updateState() {
        const currentY = window.scrollY;
        const diff = currentY - this.lastScrollY;

        const stickyVisible = this.hideWhenStickyVisible && this.isStickyOverlayVisible();
        if (stickyVisible) {
          this.classList.add('is-covered-by-sticky');
          this.classList.add('is-hidden');
          this.lastScrollY = currentY;
          return;
        }

        this.classList.remove('is-covered-by-sticky');

        if (!this.hideOnScroll) {
          this.classList.remove('is-hidden');
          this.lastScrollY = currentY;
          return;
        }

        if (Math.abs(diff) < this.scrollThreshold) {
          this.lastScrollY = currentY;
          return;
        }

        if (diff > 0 && currentY > 20) {
          this.classList.add('is-hidden');
        } else if (diff < 0) {
          this.classList.remove('is-hidden');
        }

        this.lastScrollY = currentY;
      }
    }
  
    if (!customElements.get('mobile-bottom-nav')) {
      customElements.define('mobile-bottom-nav', MobileBottomNav);
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pozze-cart-drawer"]) return;
  try {
    
(function () {
  var root = document.getElementById('pz-cart');
  if (!root || root.dataset.pzBound === 'true') return;
  root.dataset.pzBound = 'true';

  // Section estática no layout: o ID da Section Rendering API é o nome do ficheiro
  var sectionId = root.dataset.sectionId || 'pozze-cart-drawer';
  var cartUrl = root.dataset.cartUrl || '/cart';
  var lastFocus = null;
  var updating = false;

  function panel() {
    return root.querySelector('.pz-cart__panel');
  }

  function open() {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var p = panel();
    if (p) p.focus();
  }

  function close() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function setBusy(state) {
    root.classList.toggle('is-busy', !!state);
  }

  function applySectionHtml(html) {
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('[data-pz-dynamic]');
    var current = root.querySelector('[data-pz-dynamic]');
    if (!next || !current) return false;
    current.innerHTML = next.innerHTML;
    return true;
  }

  function sectionsUrl() {
    var rootPath = '/';
    try {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) {
        rootPath = Shopify.routes.root;
      }
    } catch (e) {}
    return rootPath + '?sections=' + encodeURIComponent(sectionId);
  }

  function refresh() {
    return fetch(sectionsUrl(), { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('section fetch failed');
        return r.json();
      })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) {
          // fallback: algumas lojas usam o id com prefixo shopify-section-
          var keys = Object.keys(data || {});
          html = keys.length ? data[keys[0]] : null;
        }
        applySectionHtml(html);
      })
      .catch(function () {});
  }

  function syncBadge(cart) {
    try {
      if (!window.Alpine || !Alpine.store('cart')) return;
      var store = Alpine.store('cart');
      if (cart && typeof store.refresh === 'function') {
        // Atualiza o badge sem disparar cart-change (fetchItems dispara e abriria o drawer)
        store.refresh(cart.item_count, cart.items);
      }
    } catch (e) {}
  }

  function changeQuantity(key, quantity) {
    if (!key || updating) return;
    updating = true;
    setBusy(true);

    fetch(window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root + 'cart/change.js'
      : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: sectionId,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          throw new Error(data.description || data.message || 'cart change failed');
        }
        var html = data.sections && data.sections[sectionId];
        if (html) {
          applySectionHtml(html);
        } else {
          return refresh();
        }
        syncBadge(data);
      })
      .catch(function () {
        return refresh();
      })
      .then(function () {
        updating = false;
        setBusy(false);
      });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-pz-open]');
    if (trigger) { e.preventDefault(); open(); return; }

    var link = e.target.closest('a[href]');
    if (link && !link.closest('#pz-cart')) {
      try {
        var path = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '') || '/';
        var target = (cartUrl || '/cart').replace(/\/$/, '') || '/cart';
        if (path === target) {
          e.preventDefault();
          open();
          return;
        }
      } catch (err) {}
    }

    if (!e.target.closest('#pz-cart')) return;

    if (e.target.closest('[data-pz-close]')) { e.preventDefault(); close(); return; }

    var dec = e.target.closest('[data-pz-dec]');
    if (dec) {
      e.preventDefault();
      var line = dec.closest('[data-pz-line]');
      var decInput = line && line.querySelector('[data-pz-qty]');
      var decVal = decInput ? parseInt(decInput.value, 10) - 1 : 0;
      changeQuantity(dec.getAttribute('data-key'), decVal < 0 ? 0 : decVal);
      return;
    }

    var inc = e.target.closest('[data-pz-inc]');
    if (inc) {
      e.preventDefault();
      var lineInc = inc.closest('[data-pz-line]');
      var incInput = lineInc && lineInc.querySelector('[data-pz-qty]');
      var incVal = incInput ? parseInt(incInput.value, 10) + 1 : 1;
      changeQuantity(inc.getAttribute('data-key'), incVal);
      return;
    }

    var rem = e.target.closest('[data-pz-remove]');
    if (rem) {
      e.preventDefault();
      changeQuantity(rem.getAttribute('data-key'), 0);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('#pz-cart [data-pz-qty]');
    if (!input) return;
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < 0) val = 0;
    changeQuantity(input.getAttribute('data-key'), val);
  });

  function cartUpdateUrl() {
    return window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root + 'cart/update.js'
      : '/cart/update.js';
  }

  function currentDiscountCodes() {
    var codes = [];
    root.querySelectorAll('[data-pz-remove-discount]').forEach(function (btn) {
      var code = btn.getAttribute('data-code');
      if (code) codes.push(code);
    });
    return codes;
  }

  function updateDiscounts(codes, opts) {
    opts = opts || {};
    if (updating) return Promise.resolve();
    updating = true;
    if (opts.busy !== false) setBusy(true);

    return fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        discount: Array.isArray(codes) ? codes.join(',') : (codes || ''),
        sections: sectionId,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) throw new Error('discount update failed');
        var html = data.sections && data.sections[sectionId];
        if (html) applySectionHtml(html);
        else return refresh();
        syncBadge(data);
        return data;
      })
      .catch(function () { return refresh(); })
      .then(function (data) {
        updating = false;
        setBusy(false);
        return data;
      });
  }

  function setCouponMessage(text, type) {
    var msg = root.querySelector('[data-pz-coupon-msg]');
    if (!msg) return;
    msg.textContent = text || '';
    msg.classList.toggle('is-success', type === 'success');
    msg.classList.toggle('is-error', type === 'error');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#pz-cart [data-pz-coupon]');
    if (!form) return;
    e.preventDefault();
    if (updating) return;

    var input = form.querySelector('[data-pz-coupon-input]');
    var button = form.querySelector('[data-pz-coupon-apply]');
    var code = input && input.value ? input.value.trim() : '';
    if (!code) return;

    var nextCodes = currentDiscountCodes().filter(function (c) {
      return c.toLowerCase() !== code.toLowerCase();
    });
    nextCodes.push(code);

    if (button) { button.disabled = true; button.classList.add('is-loading'); }

    updateDiscounts(nextCodes, { busy: false })
      .then(function (data) {
        var applied = true;
        if (data && Array.isArray(data.discount_codes)) {
          var found = data.discount_codes.filter(function (d) {
            return d.code && d.code.toLowerCase() === code.toLowerCase();
          })[0];
          applied = !!(found && found.applicable !== false);
        }
        if (applied) {
          setCouponMessage((root.dataset.msgCouponApplied || 'Cupom [code] aplicado!').replace('[code]', code.toUpperCase()), 'success');
        } else {
          var failInput = root.querySelector('[data-pz-coupon-input]');
          if (failInput) failInput.value = code;
          setCouponMessage(root.dataset.msgCouponInvalid || 'Cupom inválido.', 'error');
        }
      })
      .then(function () {
        var btn = root.querySelector('[data-pz-coupon-apply]');
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
      });
  });

  document.addEventListener('click', function (e) {
    var removeDiscount = e.target.closest('#pz-cart [data-pz-remove-discount]');
    if (!removeDiscount) return;
    e.preventDefault();
    var code = removeDiscount.getAttribute('data-code');
    if (!code) return;
    var remaining = currentDiscountCodes().filter(function (c) {
      return c.toLowerCase() !== code.toLowerCase();
    });
    updateDiscounts(remaining);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab' || !root.classList.contains('is-open')) return;
    var p = panel();
    if (!p) return;
    var focusables = p.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Abre na hora; refresh em paralelo (o atraso vinha de esperar o fetch antes de abrir)
  window.addEventListener('show-cart', function () {
    open();
    refresh();
  });

  // cart-change: também dispara no load via fetchItems() — NÃO abrir, só refrescar se já estiver aberto
  window.addEventListener('cart-change', function () {
    if (updating) return;
    if (root.classList.contains('is-open')) refresh();
  });

  window.pzCart = { open: open, close: close, refresh: refresh };
})();

  } catch(e) { console.error(e); }
})();
})();
